'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isInteger;
/**
 * Check if a value is an integer
 *
 * @param param Value that will be checked if it is an integer
 * @returns {boolean} Returns `true` when param is a integer otherwise false
 *
 * @example
 * isInteger(17); // Returns: true
 *
 * @example
 * isInteger(0xFF); // Returns: true
 *
 * @example
 * isInteger(-17); // Returns: true
 *
 * @example
 * isInteger(2e-3); // Returns: false
 */
function isInteger(param) {
  return typeof param === 'number' && parseFloat(param) == parseInt(param, 10) && !isNaN(param);
}
//# sourceMappingURL=isInteger.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-utilizr/lib/isInteger.js
 ** module id = 77
 ** module chunks = 0 1
 **/